import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { AppConstants } from 'src/app/commons/app-constants';

/** ALPHA feature flag — quality/color grading. Mirrors BetaService's load-once pattern. */
@Injectable({ providedIn: 'root' })
export class QualityService {
  private readonly qualityEnabledSubject = new BehaviorSubject<boolean>(false);
  readonly qualityEnabled$ = this.qualityEnabledSubject.asObservable();

  private loaded = false;

  constructor(private http: HttpClient) {}

  get qualityEnabled(): boolean {
    return this.qualityEnabledSubject.value;
  }

  load(): void {
    if (this.loaded) return;
    this.loaded = true;
    this.http
      .get<{ qualityEnabled: boolean }>(`${AppConstants.API_URL}api/v1/app/quality`)
      .subscribe({
        next: (res) => this.qualityEnabledSubject.next(res.qualityEnabled),
        error: () => { /* silently ignore — quality UI stays hidden */ },
      });
  }

  refresh(): void {
    this.loaded = false;
    this.load();
  }

  setFromBootstrap(qualityEnabled: boolean): void {
    this.loaded = true;
    this.qualityEnabledSubject.next(qualityEnabled);
  }
}
